<template>
  <div v-show="HasShowForm" @keyup.enter="OnKeyUpEnter">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-bottom-radius-8">
          <div class="card-header text-third">
            <strong><i class="icon-note"></i>&nbsp; {{this.title}}</strong>
            <div class="card-actions" v-show="HasHelp" >
                <a href="javascript:void(0);" target="_blank" v-b-tooltip.hover :title="$lang.Common.Tooltip.LearnToUse" placement="left">
                  <i class="icon-question text-third"></i>
                </a>
            </div>
          </div>
          <div class="card-block">
            <form autocomplete="off" role="presentation">
              <slot></slot>
            </form>
          </div>
          <div class="card-footer card-bottom-radius-8">
            <div class="row">
              <div class="col-md-6">
                <button type="button" class="btn btn-third btn-sm" v-show="HasButtonSearch" v-on:click="$emit('Search')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSearch"><i class="fa fa-search"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Search}}</span></button>&nbsp;
                <button type="button" class="btn btn-third btn-sm" v-show="HasButtonSave" v-on:click="$emit('Save')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"><i class="fa fa-check-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Save}}</span></button>&nbsp;
                <button type="button" class="btn btn-default btn-sm text-secundary" v-show="HasButtonClear" v-on:click="$emit('Clear')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonClear"><i class="fa fa-minus-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Clear}}</span></button>&nbsp;&nbsp;
              </div>
              <div class="col-md-6 text-right">
                <button type="button" class="btn btn-fourth btn-sm" v-show="HasButtonExport" v-on:click="$emit('Export')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonExportExcel"><i class="fa fa-download"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.ExportExcel}}</span></button>&nbsp;
                <button v-if="!isModal" type="button" class="btn btn-third btn-sm" v-show="HasButtonBack" v-on:click="$emit('Back')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonBack"><i class="fas fa-undo"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Back}}</span></button>
                <button type="button" class="btn btn-info btn-sm" v-show="HasButtonNew" v-on:click="$emit('New')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonNew"><i class="fa fa-pencil"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.New}}</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RequiredFieldBlock :showMessage="showTipFooter" :message="messageTipFooter" :type="messageTypeTipFooter" />
  </div>
</template>
<script>
import RequiredFieldBlock from './RequiredFieldBlock'

export default {
  name: 'Forms',
  data () {
    return {
      showForm: true
    }
  },
  props: {
    title: {
      type: String,
      required: true,
      default: function () {
        return this.$lang.TitleForms
      }
    },
    showHelp: {
      type: Boolean,
      default: false
    },
    showClearButton: {
      type: Boolean,
      default: false
    },
    showSaveButton: {
      type: Boolean,
      default: false
    },
    showSearchButton: {
      type: Boolean,
      default: false
    },
    showExportButton: {
      type: Boolean,
      default: false
    },
    showNewButton: {
      type: Boolean,
      default: false
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    showTipFooter: {
      type: Boolean,
      required: false,
      default: true
    },
    messageTipFooter: {
      type: String,
      required: false
    },
    messageTypeTipFooter: {
      type: String,
      required: false
    },
    disabledKeyUpEnter: {
      type: Boolean,
      required: false,
      default: false
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RequiredFieldBlock
  },
  computed: {
    HasShowForm: function () {
      return this.showForm
    },
    HasHelp: function () {
      return this.showHelp
    },
    HasButtonClear: function () {
      return this.showClearButton
    },
    HasButtonSave: function () {
      return this.showSaveButton
    },
    HasButtonExport: function () {
      return this.showExportButton
    },
    HasButtonSearch: function () {
      return this.showSearchButton
    },
    HasButtonNew: function () {
      return this.showNewButton
    },
    HasButtonBack: function () {
      return this.showBackButton
    }
  },
  methods: {
    ClearForm () {
      if (this.HasButtonClear) {
        this.$emit('Clear')
      }
    },
    SaveForm () {
      if (this.HasButtonSave && !this.disabledKeyUpEnter) {
        this.$emit('Save')
      }
    },
    SearchForm () {
      if (this.HasButtonSearch) {
        this.$emit('Search')
      }
    },
    ExportForm () {
      if (this.HasButtonExport) {
        this.$emit('Export')
      }
    },
    ValidateForm () {
      console.log('VALIDAR')
      console.log(this.$children)
      return false
    },
    OnKeyUpEnter () {
      if (this.HasButtonSave && !this.disabledKeyUpEnter) {
        this.$emit('Save')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/Forms.vue